/**Dependencies */
import React from 'react';

/**Styles */
import '../styles/hotels.scss';

export const BannerParallax = ({img, title , subtitle}) => {
  return (
    <div className="image-hover-card py-5">
        <div className="image-container-parallax">
          <img src={img} alt="Viajar es sentirte parte de tu destino"/>
          <div className="text-overlay">
            <h1 style={{fontSize: "50px"}}>{title}</h1>
            <p fontSize="22px">{subtitle}</p>
          </div>
        </div>
    </div>
  )
}
